<div class="row container-form-list mb-4">
    <div class="col-12">
        <div class="row">
            <div class="col-12 col-md-4">
                <label for="prazoMedio" class="col-form-label">Prazo Médio</label>
                <div class="input-group">
                    <input type="number" class="form-control" [(ngModel)]="prazoMedio" id="prazoMedio" name="prazoMedio"
                        (ngModelChange)="onChangePrazoMedio()">
                    <div class="input-group-append">
                        <span class="input-group-text">Dia(s)</span>
                    </div>                         
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <p class="form-text text-muted">Informe o prazo médio manualmente ou informe os prazos abaixo para calcular automaticamente</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h6 class="card-title">
                            Informe os prazos desta condição de pagamento
                        </h6>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped table-hover table-bordered">
                            <thead>
                                <tr>
                                <th class="col-delete"></th>
                                <th class="col-prazo">Prazo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let entity of entities; let i = index">
                                    <td class="col-delete">
                                        <a class="btn btn-link" (click)="delete(i)">
                                            <i class="far fa-trash-alt" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                    <td class="col-prazo">
                                        <input type="number" class="form-control" [(ngModel)]="entity.prazo" name="prazo{{i}}" id="prazo{{i}}"
                                            #prazo="ngModel" (ngModelChange)="onChangePrazo()" [autofocus]="true">
                                    </td>
                                </tr>
                                <tr *ngIf="entities.length === 0" class="no-record">
                                    <td class="text-center" colspan="2">
                                        <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <button type="button" class="btn btn-primary btn-sm" (click)="insert()">
                            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar
                        </button>
                    </div>
                </div>

            </div>
        </div>


    </div>
</div>
